<div class="field has-addons is-full-width">
  <div class="control is-addon min-width-min-content" [portalTooltip]="getTooltipTextAttribute()">
    <ng-container *ngIf="!currencyIsSelectable">
      <span
        class="button is-static is-full-width"
        data-e2e="empty-currency"
        *ngIf="!currency.value"
      >
        Currency
      </span>
      <span class="button is-static is-full-width" data-e2e="currency-value" *ngIf="currency.value">
        {{ currency.value }}
      </span>
    </ng-container>
    <div class="select min-width-min-content" *ngIf="currencyIsSelectable">
      <select
        class="is-size-7-mobile min-width-min-content"
        [formControl]="currency"
        data-e2e="select-currency"
        (change)="onCurrencySelected()"
        autocomplete="transaction-currency"
        aria-label="Currency"
        i18n-aria-label
      >
        <option *ngFor="let currencyOption of currencies" [ngValue]="currencyOption.code">
          {{ currencyOption.code }}
        </option>
      </select>
    </div>
  </div>
  <div class="control pl-0" [class.is-flex-grow-1]="expandAmountField" *ngIf="!isCustomValidation">
    <input
      class="input is-size-7-mobile"
      name="input-currency-mask"
      [class.is-danger]="invalid"
      currencyMask
      (input)="onInputChange($event)"
      [options]="amountMask"
      [formControl]="amount"
      [autocomplete]="false"
      [attr.id]="id"
      [maxlength]="maxLength ? maxLength : false"
      (ngModelChange)="onAmountSelected()"
      data-e2e="input-amount"
      pattern="\d*\.?\d*"
      type="text"
      inputmode="decimal"
      [attr.disabled]="isAmountDisabled ? true : null"
      placeholder="Enter Amount"
      i18n-placeholder
    />
  </div>
  <div class="control pl-0" [class.is-flex-grow-1]="expandAmountField" *ngIf="isCustomValidation">
    <input
      class="input is-size-7-mobile has-text-right"
      name="input-currency-mask-custom"
      [class.is-danger]="invalid"
      [formControl]="amount"
      [autocomplete]="false"
      [attr.id]="id"
      data-e2e="input-amount-custom"
      type="text"
      inputmode="decimal"
      [attr.disabled]="isAmountDisabled ? true : null"
      placeholder="Enter Amount"
      [maxlength]="maxLength ? maxLength : false"
      (input)="onRawInput($event)"
      (focus)="onInputFocus($event)"
      (blur)="onInputBlurAndFormat($event)"
      i18n-placeholder
    />
  </div>
</div>
